import { createAction, createActionGroup, props } from '@ngrx/store';

// Models
import { AutoPayCase, Contract } from '@core/models/warranty.interface';



export const WarrantyRecoveryActions = createActionGroup({
  source: 'Recovery',
  events: {
    'get something': props<{ payload: any }>(),
    'post something': props<{ payload: any }>(),
    'put something': props<{ payload: any }>(),
    'delete something': props<{ payload: any }>(),
  },
});


export const WarrantyRecoveryEffectsActions = createActionGroup({
  source: 'API Recovery',
  events: {
    'inject contracts': props<{ contracts: Contract[], total: number }>(),
    'fill out contracts table selectors': props<any>(),
    'inject contracts table selectors': props<{ selectors: any }>(),
    'get contracts': props<{ page: number, search: string, store: number, criticality: string }>(),
    'export contracts to excel': props<{ store: string }>(),
    'contracts successfully exported': props<any>(),
    'contracts failed export': props<any>(),
    'inject error': props<{ error: any }>(),
    'get auto pay cases': props<any>(),
    'inject auto pay cases': props<{ autoPayCases: Record<string, Omit<AutoPayCase, 'name'>> }>(),
  },
});
